define('webshopCategoryAddView',[
  'module',
  'backbone',
  'marionette',
  'underscore',
  'webshopCategorySelectView',
  'textView',
  'template!webshopCategoryAddView'
], function (
  Module,
  Backbone,
  Marionette,
  _,
  CategorySelectView,
  TextView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'webshop-category-add-view',

    regions: {
      codeRegion: '.code-region',
      categorySelectRegion: '.category-region'
    },

    onRender: function() {
      this.codeView = new TextView({
        value: this.model.get('code'),
        tabindex: 0,
        placeholder: _.i18n('category.add.code.placeholder')
      });     
      this.getRegion('codeRegion').show(this.codeView);
       this.codeView.on('change', _.bind(function(value) {
        this.model.set('code', value);
      }, this));

      //----------------
      this.categorySelectView = new CategorySelectView({      
        onChange: _.bind(function (model) {
          var defer = $.Deferred();
          this.model.set('parentId', model.get('id'));      
          defer.resolve();  
          return defer.promise();
        }, this)       
      });    
      this.getRegion('categorySelectRegion').show(this.categorySelectView);     
    }
  });
});
  
